module.exports = __webpack_public_path__ + "img/f3.dd538544.jpg";